import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const API_BASE = process.env.VUE_APP_API_BASE || '/api'

export default new Vuex.Store({
  state: {
    user: null,
    token: null
  },
  mutations: {
    SET_USER(state, user) { state.user = user },
    SET_TOKEN(state, token) { state.token = token },
    CLEAR_AUTH(state) { state.user = null; state.token = null }
  },
  actions: {
    async restoreSession({ commit }, token) {
      commit('SET_TOKEN', token)
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
      try {
        const { data } = await axios.get(`${API_BASE}/auth/me`)
        commit('SET_USER', data.user)
      } catch {
        commit('CLEAR_AUTH')
        localStorage.removeItem('emochi_token')
      }
    },
    async login({ commit }, { username, password }) {
      const { data } = await axios.post(`${API_BASE}/auth/login`, { username, password })
      commit('SET_TOKEN', data.token)
      commit('SET_USER', data.user)
      localStorage.setItem('emochi_token', data.token)
      axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`
    },
    async register({ commit }, { username, password, nickname }) {
      const { data } = await axios.post(`${API_BASE}/auth/register`, { username, password, nickname })
      commit('SET_TOKEN', data.token)
      commit('SET_USER', data.user)
      localStorage.setItem('emochi_token', data.token)
      axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`
    },
    logout({ commit }) {
      commit('CLEAR_AUTH')
      localStorage.removeItem('emochi_token')
      delete axios.defaults.headers.common['Authorization']
    }
  }
})
